/**
 *
 * CollaboratorsModal
 *
 */

import React, { Component } from "react"
import { Modal, Button, Input, Table } from "antd"
import { filter, orderBy } from "lodash"
import userIcon from "../../images/user_icon.svg"

import "./index.less"
import { CloseCircleOutlined, SearchOutlined } from "@ant-design/icons"

class CollaboratorsModal extends Component {
  state = {
    stateCollaborators: [],
    inputSearchCollaborators: "",
    countCollaborators: 0,
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.data.length !== this.props.data.length) {
      if (prevState.stateCollaborators.length !== this.props.data.length) {
        this.setState({
          stateCollaborators: this.props.data,
          countCollaborators: this.props.data.length,
        })
      }
    }
  }

  componentDidMount = () => {
    this.setState({
      stateCollaborators: this.props.data,
      countCollaborators: this.props.data.length,
    })
  }

  handleSearchChange = (value) => {
    this.setState({
      inputSearchCollaborators: value,
      stateCollaborators: filter(this.props.data, (item) => {
        return (
          item.full_name.toLowerCase().includes(value.toLowerCase()) ||
          item.position_name.toLowerCase().includes(value.toLowerCase())
        )
      }),
    })
  }

  render() {
    const columns = [
      {
        title: "Colaborador",
        key: "collaborator",
        width: 280,
        // onFilter: (value, record) => record.full_name.indexOf(value) === 0,
        sorter: (a, b) => a.full_name.localeCompare(b.full_name),
        render: (text, record) => {
          return (
            <div className="colaboratorColumn">
              <img src={record.picture_profile} />
              <span>
                {text.first_name} {text.last_name}
              </span>
            </div>
          )
        },
      },
      {
        title: "Puesto",
        key: "position_name",
        dataIndex: "position_name",
        render: (text) => {
          return (
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span style={{ fontSize: 13 }}>{text}</span>
              <img src={userIcon} style={{ cursor: "pointer" }} />
            </div>
          )
        },
      },
    ]

    return (
      <Modal
        className="collaboratorsModal"
        width={650}
        visible={this.props.openModal}
        title={this.props.divisionName}
        onCancel={() => this.props.onOk()}
        closable={false}
        footer={[
          <Button key="accept" type="primary" onClick={() => this.props.onOk()}>
            Aceptar
          </Button>,
        ]}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 8,
          }}>
          <span style={{ color: "rgba(130, 130, 130, 0.83)", fontSize: 13 }}>
            {this.state.countCollaborators} colaboradores
          </span>
          <Input
            placeholder="Buscar..."
            value={this.state.inputSearchCollaborators}
            onChange={(e) => this.handleSearchChange(e.target.value)}
            style={{ width: 200, marginLeft: "1rem" }}
            suffix={
              this.state.inputSearchCollaborators ? (
                <CloseCircleOutlined
                  style={{
                    cursor: "pointer",
                    color: "white",
                    background: "rgba(0, 0, 0, 0.25)",
                    borderRadius: "50%",
                  }}
                  onClick={() => this.handleSearchChange("")}
                />
              ) : (
                <SearchOutlined />
              )
            }
          />
        </div>
        <Table
          loading={this.props.loading}
          scroll={{ y: 284 }}
          rowKey={(record) => record.id_employee}
          className="tableCollaborator"
          columns={columns}
          dataSource={orderBy(this.state.stateCollaborators, "full_name")}
          pagination={false}
        />
      </Modal>
    )
  }
}

CollaboratorsModal.propTypes = {}

export default CollaboratorsModal
